import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { Icon } from '@ui';
import { FC } from 'react';
import { cn } from '@/utils';

type Props = {
  rating: number;
  className?: string;
  starClassName?: string;
};

const RatingStars: FC<Props> = ({ rating, className, starClassName }) => (
  <div className={cn('flex items-center gap-1', className)}>
    {Array.from({ length: 5 }, (_, i) => (
      <Icon
        key={i}
        className={cn(starClassName, i + 1 <= rating ? 'text-warning' : 'text-default-500')}
        icon={faStar}
      />
    ))}
  </div>
);

export default RatingStars;
